import { useEffect } from 'react';
import useClientQuery from 'ui/hooks/useClientQuery';
import useLoanApplicationQuery from 'ui/hooks/useLoanApplicationQuery';

const useTestingTool = () => {
  const { data: clientData } = useClientQuery();
  const loanApplicationQuery = useLoanApplicationQuery();

  const clientID = clientData?.id;
  const applicationID = loanApplicationQuery.loanApplication?.id;

  useEffect(() => {
    const testingData: { clientID?: string; applicationID?: string } = {};

    if (clientID) testingData.clientID = String(clientID);
    if (applicationID) testingData.applicationID = String(applicationID);
  }, [clientID, applicationID]);
};

export default useTestingTool;
